import React from 'react';
import { Box, Paper } from '@mui/material';
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip, Legend, type ChartOptions, type Plugin } from 'chart.js';
import { Bar } from 'react-chartjs-2';

Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);


interface BarchartProps {
  data?: number[];
  labels?: string[];
  // [key: string]: any;
}

const Barchart: React.FC<BarchartProps> = ({ data: propData, labels: propLabels, ...props }) => {
  const labels = propLabels || ['<30', '30-34', '35-37', '38-40', '>40'];
  const dataValues = propData || [72, 50, 78, 71.2, 62];

  // Plugin to draw data labels above bars and a threshold line at 75%
  const dataLabelPlugin: Plugin<'bar'> = {
    id: 'customLabelsAndThreshold',
    afterDraw: (chart) => {
      const ctx = chart.ctx;
      const yScale = chart.scales['y'];
      if (!yScale) return;

      // draw threshold line at 75
      const thresholdValue = 75;
      const y = yScale.getPixelForValue(thresholdValue);
      ctx.save();
      ctx.strokeStyle = 'rgba(225,126,97,0.45)';
      ctx.setLineDash([6, 6]);
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(chart.chartArea.left, y);
      ctx.lineTo(chart.chartArea.right, y);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(225,126,97,1)';
      ctx.font = '12px Montserrat';
      ctx.fillText(`Standard Rate : ≥ ${thresholdValue}%`, chart.chartArea.right - 180, y - 8);
      ctx.restore();

      // draw labels above bars
      chart.data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        meta.data.forEach((bar, index) => {
          const value = dataset.data[index] as number;
          // rectangle element has x and y properties
          const rect = bar as unknown as { x: number; y: number };
          const barCenterX = rect.x;
          const barTop = rect.y;
          ctx.save();
          ctx.fillStyle = '#232323';
          ctx.font = '700 12px Montserrat';
          ctx.textAlign = 'center';
          ctx.fillText(`${value}%`, barCenterX, barTop - 8);
          ctx.restore();
        });
      });
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Maturation Rate',
        data: dataValues,
        backgroundColor: '#ECECF2',
        hoverBackgroundColor: labels.map(() => '#54566A'),

        borderRadius: 8,
        barThickness: 64,
      },
    ],
  };

  const options: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: '#9E9E9E' },
      },
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
          color: '#9E9E9E',
        },
        grid: {
          color: 'rgba(0,0,0,0.05)'
        },
      },
    },
    elements: {
      bar: { borderRadius: 8 },
    },
  };

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }} {...props}>
      <Box sx={{ width: '100%', height: { xs: 420, sm: 520 }, minHeight: { xs: 360, md: 420 } }}>
        <Box sx={{ width: '100%', height: '100%' }}>
          <Bar data={data} options={options} plugins={[dataLabelPlugin]} />
        </Box>
      </Box>
    </Paper>
  );
};

export default Barchart;
